<template>
  <div class="newvoice">
    <!-- <div @click="navToDetail" class="newvoice-cover">
      <img :src="obj.image" class="newvoice-cover-img" alt="" />
      <img
        src="../../../assets/images/voice.png"
        class="newvoice-cover-icon"
        alt=""
      />
    </div> -->
    <!-- <a target="_blank" :href="obj.wx_url" @click="navToDetail" class="newvoice-cover">
      <img :src="obj.image" class="newvoice-cover-img" alt="" />
      <img
        src="../../../assets/images/voice.png"
        class="newvoice-cover-icon"
        alt=""
      />
    </a> -->
    <div target="_blank" @click="navToDetail" class="newvoice-cover">
      <img :src="obj.image" class="newvoice-cover-img" alt="" />
      <img
        src="../../../assets/images/voice.png"
        class="newvoice-cover-icon"
        alt=""
      />
    </div>
    <div @click="navToDetail" class="newvoice-title">
      {{ obj.title }}
    </div>
    <div class="newvoice-author">作者：{{ obj.author }}</div>
    <div class="newvoice-anchor">主播：{{ obj.anchor }}</div>
    <div class="newvoice-time">时间：{{ obj.created_at | formatTime }}</div>
  </div>
</template>

<script>
import tools from "../../../utils/methods";
export default {
  components: {},
  props: {
    obj: Object,
    authority: Array,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    async addViews() {
      try {
        let res = await this.$api.addqqListenView({
          params: {
            "access-token": localStorage.getItem("token"),
            id: this.obj.id,
          },
          data: {},
        });
      } catch (err) {}
    },

    navToDetail() {
      if (this.authority.includes("青青听")) {
        this.addViews().then((res) => {});
        window.open(this.obj.wx_url);
      } else {
        this.$message.closeAll();
        this.$message({
          message: "暂无权限,请与图书馆联系",
          offset: 400,
          type:'warning'
        });
      }
    },
  },
  created() {},
  filters: {
    formatTime(value) {
      let d = new Date();
      let res = "";
      if (value) {
        d.setTime(value * 1000);
        let date = d.toLocaleDateString().replace(/\//gi, "-");
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;
        let time = d.toTimeString().slice(0, 5);
        res = `${year}-${month}-${day} ${time}`;
      }
      return res;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.newvoice {
  width: 261px;
  display: flex;
  flex-direction: column;
  &-cover {
    position: relative;
    height: 261px;
    background-color: #58b75b;
    border-radius: 10px;
    display: flex;
    cursor: pointer;
    &-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
    &-icon {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }
  &-title {
    color: #333;
    margin-top: 36px;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  &-author {
    color: #999;
    line-height: 1.6;
    margin-top: 18px;
    font-size: 12px;
  }
  &-anchor {
    line-height: 1.6;
    color: #999;
    font-size: 12px;
  }
  &-time {
    color: #999;
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/newvoiceItem.vue